import {
  useState,
  useEffect,
  createContext
} from 'react';

import {
  AppBar,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Button,
  CssBaseline,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  TextField,
  Toolbar,
  Typography
} from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';

import ListIcon from '@mui/icons-material/List';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';

import theme from './theme';

import ListTab from './ListTab';
import GalleryTab from './GalleryTab';

import AllData from '../data/all.json';
import S1M1Data from '../data/s1-m1.json';
import S1M2Data from '../data/s1-m2.json';
import S1M3Data from '../data/s1-m3.json';
import S2M1Data from '../data/s2-m1.json';
import S2M2Data from '../data/s2-m2.json';
import S2M3Data from '../data/s2-m3.json';
import S3M1Data from '../data/s3-m1.json';
import S3M2Data from '../data/s3-m2.json';
import S3M3Data from '../data/s3-m3.json';

const DataSets = {
  s1m1: S1M1Data,
  s1m2: S1M2Data,
  s1m3: S1M3Data,
  s2m1: S2M1Data,
  s2m2: S2M2Data,
  s2m3: S2M3Data,
  s3m1: S3M1Data,
  s3m2: S3M2Data,
  s3m3: S3M3Data,
}

const insecteraLogoUrl = new URL('../img/logo.jpg', import.meta.url);

export const AppContext = createContext();

export function App() {

  const [context, setContext] = useState({
    tab: 0,
    posterIndex: 0
  });

  const [postersData, setPostersData] = useState(null);
  const [mupiName, setMupiName] = useState(localStorage.getItem('mupiName') || 'Mupi');
  const [mupiNameDialogOpen, setMupiNameDialogOpen] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has('set'))
      setPostersData(DataSets[searchParams.get('set')] || []);
    else
      setPostersData(AllData);

    console.log(AllData);
  }, []);

  useEffect(() => {
    localStorage.setItem('mupiName', mupiName);
  }, [mupiName]);

  return (
    <AppContext.Provider value={{
      ...context,
      setPosterIndex: (index) => {
        setContext({
          ...context,
          posterIndex: index
        });
      },
      setTab: (tab) => {
        setContext({
          ...context,
          tab
        });
      },
      setContext
    }}>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        }}>

          <Box>
            <AppBar position="static">
              <Toolbar sx={{ pt: '2.5px', backgroundColor: 'white' }}>
                <Box 
                  onClick={(event) => {
                    setContext({
                      ...context,
                      tab: 0
                    });
                  }}
                  sx={{ cursor: 'pointer' }}
                >
                  <img src={insecteraLogoUrl} width="100px" alt="Logo Insectera" />
                </Box>
                <Typography variant="h6" sx={{ flexGrow: 1 }}></Typography>
                <Button onClick={() => setMupiNameDialogOpen(true)}><Box>{mupiName}</Box></Button>
              </Toolbar>
            </AppBar>
          </Box>

          <Box sx={{
            flexGrow: 1,
            minHeight: 0,
            overflow: 'hidden'
          }}>
            {context.tab == 0 && <ListTab postersData={postersData} />}
            {context.tab == 1 && <GalleryTab postersData={postersData} />}
          </Box>

          <Box>
            <Paper elevation={4}>
              <BottomNavigation
                showLabels
                value={context.tab}
                onChange={(event, newValue) => {
                  setContext({
                    ...context,
                    tab: newValue
                  });
                }}
              >
                <BottomNavigationAction label="Ver em Lista" icon={<ListIcon />} />
                <BottomNavigationAction label="Ver em Galeria" icon={<ViewCarouselIcon />} />
              </BottomNavigation>
            </Paper>
          </Box>

        </Box>

        {mupiNameDialogOpen && (
          <Dialog
            open={mupiNameDialogOpen}
            onClose={() => setMupiNameDialogOpen(false)}
          >
            <DialogTitle>Nome do Mupi</DialogTitle>
            <DialogContent>
              <TextField
                sx={{ marginTop: 1 }}
                label="Nome"
                onChange={(event) => {
                  if (event.target.value) {
                    setMupiName(event.target.value);
                  }
                }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => {
                setMupiNameDialogOpen(false);

              }}>
                Fechar
              </Button>
            </DialogActions>
          </Dialog>
        )}

      </ThemeProvider>
    </AppContext.Provider>
  );
}
